/**
 * eRCMS.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ModelCase } from './modelCase';
import { TransmitStatus } from './transmitStatus';

export interface Outcome { 
    id?: string;
    caseId?: string;
    _case?: ModelCase;
    remark?: string;
    approved?: boolean;
    attachmentFileId?: string;
    attachment?: any;
    createdByUserId?: string;
    createdDate?: Date;
    transmitStatus?: TransmitStatus;
    isAnonymized?: boolean;
    isShared?: boolean;
    decisionDate?: Date;
}